import { render, staticRenderFns } from "./loginuser_gov.vue?vue&type=template&id=00abea75&scoped=true&"
import script from "./loginuser_gov.vue?vue&type=script&lang=js&"
export * from "./loginuser_gov.vue?vue&type=script&lang=js&"
import style0 from "./loginuser_gov.vue?vue&type=style&index=0&id=00abea75&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00abea75",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VTextField})
